import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { getIsLoggingOut } from '../services/api'

// Importar as páginas
import LoginPage from '../pages/LoginPage.vue'
import RegisterPage from '../pages/RegisterPage.vue'
import DashboardPage from '../pages/DashboardPage.vue'
import WorkspacePage from '../pages/WorkspacePage.vue'

// Páginas do Sistema (Home)
import AllWorkspacesPage from '../pages/AllWorkspacesPage.vue'
import AgendaPage from '../pages/AgendaPage.vue'
import HistoriaPage from '../pages/HistoriaPage.vue'
import RelatoriosPage from '../pages/RelatoriosPage.vue'
import FinanceiroPage from '../pages/FinanceiroPage.vue'
import WorkspacePermissoesPage from '../pages/WorkspacePermissoesPage.vue'
import UpgradePage from '../pages/UpgradePage.vue'
import MeuPerfilPage from '../pages/MeuPerfilPage.vue'
import SuportePage from '../pages/SuportePage.vue'
import EstruturacaoPage from '../pages/EstruturacaoPage.vue'
import EstruturacaoSectionPage from '../pages/EstruturacaoSectionPage.vue'
import SuperAdminPage from '../pages/SuperAdminPage.vue'
import { ESTRUTURACAO_SECTIONS } from '../constants/estruturacaoSections'

// Páginas do Workspace
import WorkspaceDashboardPage from '../pages/WorkspaceDashboardPage.vue'
import WorkspaceConfiguracoesPage from '../pages/WorkspaceConfiguracoesPage.vue'
import WorkspaceUsuariosPage from '../pages/WorkspaceUsuariosPage.vue'
import WorkspaceBacklogPage from '../pages/WorkspaceBacklogPage.vue'
import WorkspaceIntegracaoPage from '../pages/WorkspaceIntegracaoPage.vue'
import WhatsAppChatbotPage from '../pages/WhatsAppChatbotPage.vue'
import KanbanPage from '../pages/KanbanPage.vue'
import WorkspaceHistoriaPage from '../pages/WorkspaceHistoriaPage.vue'
import WorkspaceAgendaPage from '../pages/WorkspaceAgendaPage.vue'
import WorkspaceRelatoriosPage from '../pages/WorkspaceRelatoriosPage.vue'
import WorkspaceAppsPage from '../pages/WorkspaceAppsPage.vue'
import WorkspaceFinanceiroEntry from '../pages/WorkspaceFinanceiroEntry.vue'
import WorkspaceClientesPage from '../pages/WorkspaceClientesPage.vue'
import WorkspaceClienteDetailPage from '../pages/WorkspaceClienteDetailPage.vue'
import WorkspaceAtividadePage from '../pages/WorkspaceAtividadePage.vue'
import WorkspaceOrcamentosPage from '../pages/WorkspaceOrcamentosPage.vue'
import WorkspaceOrcamentoEditorPage from '../pages/WorkspaceOrcamentoEditorPage.vue'

// Páginas de Convite
import AcceptInvitePage from '../pages/AcceptInvitePage.vue'
import PublicLeadFormPage from '../pages/PublicLeadFormPage.vue'
import PublicAgendamentoFormPage from '../pages/PublicAgendamentoFormPage.vue'
import PublicOrcamentoPage from '../pages/PublicOrcamentoPage.vue'

// Página de Acesso Negado
import AcessoNegadoPage from '../pages/AcessoNegadoPage.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage,
    meta: { requiresGuest: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true, screenId: 'system-dashboard' }
  },
  {
    path: '/system-dashboard',
    redirect: '/dashboard'
  },
  {
    path: '/workspace/:id',
    name: 'Workspace',
    component: WorkspacePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspaces',
    name: 'AllWorkspaces',
    component: AllWorkspacesPage,
    meta: { requiresAuth: true, screenId: 'workspaces' }
  },
  {
    path: '/agenda',
    name: 'Agenda',
    component: AgendaPage,
    meta: { requiresAuth: true, screenId: 'agenda' }
  },
  {
    path: '/historia',
    name: 'Historia',
    component: HistoriaPage,
    meta: { requiresAuth: true, screenId: 'historia' }
  },
  {
    path: '/relatorios',
    name: 'Relatorios',
    component: RelatoriosPage,
    meta: { requiresAuth: true, screenId: 'relatorios' }
  },
  {
    path: '/financeiro',
    name: 'Financeiro',
    component: FinanceiroPage,
    meta: { requiresAuth: true, screenId: 'financeiro' }
  },
  {
    path: '/workspace-permissoes',
    name: 'WorkspacePermissoes',
    component: WorkspacePermissoesPage,
    meta: { requiresAuth: true, screenId: 'workspace-permissoes' }
  },
  {
    path: '/upgrade',
    name: 'Upgrade',
    component: UpgradePage,
    meta: { requiresAuth: true, screenId: 'upgrade' }
  },
  {
    path: '/meu-perfil',
    name: 'MeuPerfil',
    component: MeuPerfilPage,
    meta: { requiresAuth: true, screenId: 'meu-perfil' }
  },
  {
    path: '/estruturacao',
    name: 'Estruturacao',
    component: EstruturacaoPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/estruturacao/comercial',
    name: 'EstruturacaoComercial',
    component: EstruturacaoSectionPage,
    props: () => ({ section: ESTRUTURACAO_SECTIONS[0] }),
    meta: { requiresAuth: true, screenId: 'estruturacao-comercial' }
  },
  {
    path: '/estruturacao/atendimentos',
    name: 'EstruturacaoAtendimentos',
    component: EstruturacaoSectionPage,
    props: () => ({ section: ESTRUTURACAO_SECTIONS[1] }),
    meta: { requiresAuth: true, screenId: 'estruturacao-atendimentos' }
  },
  {
    path: '/estruturacao/operacional',
    name: 'EstruturacaoOperacional',
    component: EstruturacaoSectionPage,
    props: () => ({ section: ESTRUTURACAO_SECTIONS[2] }),
    meta: { requiresAuth: true, screenId: 'estruturacao-operacional' }
  },
  {
    path: '/estruturacao/financeira',
    name: 'EstruturacaoFinanceira',
    component: EstruturacaoSectionPage,
    props: () => ({ section: ESTRUTURACAO_SECTIONS[3] }),
    meta: { requiresAuth: true, screenId: 'estruturacao-financeira' }
  },
  {
    path: '/suporte',
    name: 'Suporte',
    component: SuportePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/super-admin',
    name: 'SuperAdmin',
    component: SuperAdminPage,
    meta: { requiresAuth: true, screenId: 'super-admin' }
  },
  {
    path: '/acesso-negado',
    name: 'AcessoNegado',
    component: AcessoNegadoPage,
    meta: { requiresAuth: true }
  },
  // Rotas do Workspace
  {
    path: '/workspace/:id/dashboard',
    name: 'WorkspaceDashboard',
    component: WorkspaceDashboardPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/configuracoes',
    name: 'WorkspaceConfiguracoes',
    component: WorkspaceConfiguracoesPage,
    meta: { requiresAuth: true, requiresWorkspaceStaff: true }
  },
  {
    path: '/workspace/:id/integracoes',
    name: 'WorkspaceIntegracao',
    component: WorkspaceIntegracaoPage,
    meta: { requiresAuth: true, requiresWorkspaceStaff: true }
  },
  {
    path: '/workspace/:id/integracoes/whatsapp/chatbot',
    name: 'WorkspaceWhatsAppChatbot',
    component: WhatsAppChatbotPage,
    meta: { requiresAuth: true, requiresWorkspaceStaff: true }
  },
  {
    path: '/workspace/:id/usuarios',
    name: 'WorkspaceUsuarios',
    component: WorkspaceUsuariosPage,
    meta: { requiresAuth: true, requiresWorkspaceStaff: true }
  },
  {
    path: '/workspace/:id/backlog',
    name: 'WorkspaceBacklog',
    component: WorkspaceBacklogPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/historia',
    name: 'WorkspaceHistoria',
    component: WorkspaceHistoriaPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/relatorios',
    name: 'WorkspaceRelatorios',
    component: WorkspaceRelatoriosPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/orcamentos',
    name: 'WorkspaceOrcamentos',
    component: WorkspaceOrcamentosPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/orcamentos/novo',
    name: 'WorkspaceOrcamentoNovo',
    component: WorkspaceOrcamentoEditorPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/orcamentos/:orcamentoId',
    name: 'WorkspaceOrcamentoEditor',
    component: WorkspaceOrcamentoEditorPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/agenda',
    name: 'WorkspaceAgenda',
    component: WorkspaceAgendaPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/clientes',
    name: 'WorkspaceClientes',
    component: WorkspaceClientesPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/clientes/:clienteId',
    name: 'WorkspaceClienteDetail',
    component: WorkspaceClienteDetailPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/financeiro',
    name: 'WorkspaceFinanceiro',
    component: WorkspaceFinanceiroEntry,
    meta: { requiresAuth: true, requiresWorkspaceStaff: true }
  },
  {
    path: '/workspace/:id/atividade',
    name: 'WorkspaceAtividade',
    component: WorkspaceAtividadePage,
    meta: { requiresAuth: true, requiresWorkspaceStaff: true }
  },
  {
    path: '/workspace/:id/kanban',
    name: 'WorkspaceKanban',
    component: KanbanPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/workspace/:id/apps',
    name: 'WorkspaceApps',
    component: WorkspaceAppsPage,
    meta: { requiresAuth: true }
  },
  // Rota para aceitar convites (não requer autenticação)
  {
    path: '/convite/:token',
    name: 'AcceptInvite',
    component: AcceptInvitePage,
    meta: { requiresGuest: false }
  },
  {
    path: '/formulario/:token',
    name: 'PublicLeadForm',
    component: PublicLeadFormPage,
    meta: { requiresGuest: false, publicForm: true }
  },
  {
    path: '/agendamento/:token',
    name: 'PublicAgendamentoForm',
    component: PublicAgendamentoFormPage,
    meta: { requiresGuest: false, publicForm: true }
  },
  {
    path: '/orcamento/:token',
    name: 'PublicOrcamento',
    component: PublicOrcamentoPage,
    meta: { requiresGuest: false, publicForm: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Cache de permissões de tela
let cachedScreenPermissions = null
let permissionsCacheTime = 0
const PERMISSIONS_CACHE_TTL = 60000

async function getScreenPermissions() {
  const now = Date.now()
  if (cachedScreenPermissions && (now - permissionsCacheTime) < PERMISSIONS_CACHE_TTL) {
    return cachedScreenPermissions
  }
  try {
    const token = localStorage.getItem('token')
    if (!token) return null
    const { default: apiClient } = await import('../services/api')
    const response = await apiClient.get('/permissoes-tela/me')
    cachedScreenPermissions = response.data
    permissionsCacheTime = now
    return cachedScreenPermissions
  } catch (error) {
    console.error('[ROUTER] Erro ao verificar permissões de tela:', error)
    return null
  }
}

export function clearPermissionsCache() {
  cachedScreenPermissions = null
  permissionsCacheTime = 0
}

// Guard de navegação
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  if (!authStore.isInitialized) {
    console.log('[ROUTER] Inicializando autenticação...')
    await authStore.initializeAuth()
  }
  
  console.log('[ROUTER] Navegando de', from.path, 'para', to.path)
  console.log('[ROUTER] isAuthenticated:', authStore.isAuthenticated)
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    console.log('[ROUTER] Rota protegida, redirecionando para login')
    next('/login')
  } 
  else if (to.meta.requiresGuest && authStore.isAuthenticated && !getIsLoggingOut()) {
    console.log('[ROUTER] Usuário já autenticado, redirecionando para dashboard')
    next('/dashboard')
  } 
  else if (to.meta.requiresWorkspaceStaff && authStore.isAuthenticated) {
    const workspaceId = to.params.id
    if (workspaceId) {
      try {
        const { default: apiClient } = await import('../services/api')
        const { data } = await apiClient.get(`/workspace-acesso/workspace/${workspaceId}/kanban-permissions/me`)
        const role = String(data?.roleWorkspace || 'MEMBER').toUpperCase()
        if (!['OWNER', 'ADMIN'].includes(role)) {
          return next()
        }
        if (to.query.staffDenied === '1') {
          const { staffDenied: _removed, ...rest } = to.query
          return next({ path: to.path, query: rest })
        }
      } catch {
        return next()
      }
    }
    next()
  }
  else if (to.meta.screenId && authStore.isAuthenticated) {
    if (to.meta.screenId === 'super-admin') {
      const roleName = authStore.user?.role?.nome
      const canAccessSuperAdmin = roleName === 'SUPER_ADMIN' || roleName === 'ADMIN'
      if (!canAccessSuperAdmin) {
        next({ path: '/acesso-negado', query: { tela: 'super-admin' } })
        return
      }
    }
    const perms = await getScreenPermissions()
    if (perms && perms[to.meta.screenId] === false) {
      console.log('[ROUTER] Acesso negado à tela:', to.meta.screenId)
      next({ path: '/acesso-negado', query: { tela: to.meta.screenId } })
    } else {
      next()
    }
  }
  else {
    console.log('[ROUTER] Permitindo navegação')
    next()
  }
})

// After each hook para carregar workspaces quando necessário
router.afterEach((to, from) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'G-ZBC1Z7TVB9', {
      page_path: to.fullPath,
      page_title: typeof document !== 'undefined' ? document.title : undefined,
    })
  }

  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView')
  }

  // Carregar workspaces após login bem-sucedido ou ao acessar páginas protegidas
  if (to.meta.requiresAuth && from.path === '/login') {
    console.log('[ROUTER] 🔄 Vindo do login para rota protegida, garantindo workspaces carregados')
    // Importar dinamicamente o composable para evitar dependência circular
    import('../composables/useGlobalWorkspaces.js').then(({ useGlobalWorkspaces }) => {
      const { loadWorkspaces } = useGlobalWorkspaces()
      loadWorkspaces()
    })
  }
})

export default router
